import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import React from 'react';

const legendSymbol = 'x';
const legendProps = {
	w: 8,
	h: 8,
	d: 'flex',
	borderRadius: '100%',
	alignItems: 'center',
	justifyContent: 'center',
	alignSelf: 'center',
	fontSize: 'sm',
	flex: '0 0 2rem',
	border: '1px solid'
};

export const LegendExplanations = () => {
	return (
		<Stack p={2}>
			<Flex align="center">
				<Box bg="blue.500" {...legendProps} borderColor="gray.300" color="white">
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Palvelu on aktiivinen
				</Text>
			</Flex>
			<Flex align="center">
				<Box bg="white" {...legendProps} borderColor="gray.300">
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Palvelu on passiivinen
				</Text>
			</Flex>

			<Flex align="center">
				<Box bg="white" {...legendProps} color="red.500" fontWeight="black" borderColor="gray.300">
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Kuluva päivä, palvelu on passiivinen{' '}
				</Text>
			</Flex>
			<Flex align="center">
				<Box
					bg="rgba(17, 34, 131, 0.2)"
					color="red.500"
					fontWeight="black"
					{...legendProps}
					borderColor="gray.300"
				>
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Kuluva päivä, palvelu on aktiivinen (tilaa ei voi muuttaa)
				</Text>
			</Flex>
			<Flex align="center">
				<Box
					bg="rgba(17, 34, 131, 0.2)	"
					color="rgba(0, 0, 0, 0.2)"
					{...legendProps}
					borderColor="gray.300"
				>
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Palvelu on aktiivinen, päivän valittua tilaa ei voi muuttaa
				</Text>
			</Flex>
			<Flex align="center">
				<Box
					bg="rgba(0, 0, 0, 0.05)"
					color="rgba(0, 0, 0, 0.2)"
					{...legendProps}
					borderRadius="25%"
					borderColor="gray.300"
					flex="0 0 2rem"
				>
					{legendSymbol}
				</Box>
				<Text fontSize="sm" ml={2}>
					Palvelu on passiivinen, päivän valittua tilaa ei voi muuttaa
				</Text>
			</Flex>
		</Stack>
	);
};
